import React from 'react'

const Pipes = (props) => {
    return (
        <div className="connector-meta-col">
            <p className="connector-meta-label">Pipes</p>
            <div className="connector-meta-value">
                <span>{props.entityCount}</span>
            </div>
        </div>
    )
}

export default Pipes
